import React from "react";
import styled from "styled-components";
import { AsyncSelecty } from "genbook-components";
import { components } from "react-select";
import { getLocalStorageItem, getOrgId } from "../../../../utils/helpers";
import debounce from "debounce-promise";
import Search from "../../../../assets/images/search.png";

class CustomerSearch extends React.Component {
  _loadOptions = inputValue => this.getOptions(inputValue);
  _debouncedLoadOptions = debounce(this._loadOptions, 350, {
    leading: true
  });

  getOptions = async inputValue => {
    if (!inputValue || inputValue.length < 3) {
      return [];
    }
    const normalizedInput = inputValue.toLowerCase();
    const response = await fetch(
      `${
        window.APP.apiPath
      }api/organization/${getOrgId()}/customers/search?value=${normalizedInput}`,
      {
        headers: { Authorization: getLocalStorageItem("token_authorization") }
      }
    );
    const JSONResponse = await response.json();
    return JSONResponse.customerlist || [];
  };

  customOption = props => {
    const { firstname, lastname, phone, email } = props.data;
    return (
      <components.Option {...props}>
        <StyledResult>
          <div>
            <span>
              {firstname} {lastname}
            </span>
            <span>{phone}</span>
          </div>
          <div>
            <span>{email}</span>
          </div>
        </StyledResult>
      </components.Option>
    );
  };

  dropdownIndicator = props => {
    return (
      <components.DropdownIndicator {...props}>
        <Styledimg src={Search} />
      </components.DropdownIndicator>
    );
  };

  render() {
    const { onChange, ...rest } = this.props;
    return (
      <AsyncSelecty
        arrowRenderer={() => <span />}
        loadOptions={inputValue => this._debouncedLoadOptions(inputValue)}
        getOptionLabel={option => `${option.firstname} ${option.lastname}`}
        components={{
          Option: this.customOption,
          DropdownIndicator: this.dropdownIndicator
        }}
        noOptionsMessage={() => null}
        onChange={val => onChange(val)}
        testId="customer-search"
        {...rest}
      />
    );
  }
}

export default CustomerSearch;

const StyledResult = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
`;

const Styledimg = styled.img`
  height: 12px;
  width: 12px;
  margin: 0.2rem;
`;
